import React from "react";
import { useSelector } from "react-redux";
import { Divider } from "@material-ui/core";
import LocalNavMenu from "../LocalNavMenu";
import LocalNavSoftLink from "../LocalNavSoftLink";
import LoginLogout from "../LoginLogout";

export default function AccountMenu() {
    const pathname = useSelector(state => state.router.location.pathname);
    const userName = useSelector(state => state.session.fullName);
    const userEmail = useSelector(state => state.session.userLogonId);
    const pwExpired = useSelector(state => state.session.pwExpired);
    const enabledFeatures = useSelector(state => state.session.enabledFeatures);

    const wayfarerMode = enabledFeatures.includes("integrate-wayfarer-header");
    if (wayfarerMode) return null; // Only shown in non-wayfarer mode

    const isAccountActive = pathname.includes("/account/");

    return (
        <li id="account" className={`menu-li account ${isAccountActive ? "active" : ""}`}>
            <LocalNavMenu
                id="account-menu"
                key="account"
                text="Account"
                isCollapsed
                collapsedIcon="/Images/Icons/account.png"
            >
                <div className="nav-description" name="description">
                    <strong>{userName}</strong>
                    <p>({userEmail})</p>
                </div>
                {!pwExpired && <Divider name="divider" />}
                {!pwExpired && (
                    <LocalNavSoftLink
                        id="manage-account"
                        destination="/account/preferences"
                        text="Manage Account"
                        removeLi
                    />
                )}
                <LoginLogout id="login-logout" />
            </LocalNavMenu>
        </li>
    );
}
